
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
props: {
preventGoBack: {
type: Boolean,
default: false
},
},
data () {
return {
}
},
components: {
XHeader
},
created(){
},
beforeCreate () {
},
mounted () {

},
beforeDestroy () {

},
methods: {
_clickBack(){
this.$emit('clickBack')
}
}
}



// WEBPACK FOOTER //
// ./src/common/components/SaafHeader.vue